<template>
    <el-table :data="tilat" size="small" class="tilat-table" style="width: 100%">
        <el-table-column label="Tilatunnus" prop="tilatunnus" show-overflow-tooltip>
            <template #default="scope">
                <div class="tilatunnus-cell">
                    <el-tag :type="isDuplicateTilatunnus(scope.row.tilatunnus) ? 'warning' : 'info'">
                        {{ scope.row.tilatunnus }}
                    </el-tag>
                    <el-icon v-if="isDuplicateTilatunnus(scope.row.tilatunnus)" color="#e6a23c">
                        <Warning />
                    </el-icon>
                </div>
            </template>
        </el-table-column>
        <el-table-column label="Pinta-ala" prop="pintaAla" show-overflow-tooltip>
            <template #default="scope">
                <span v-if="scope.row.pintaAla">{{ scope.row.pintaAla }} m²</span>
                <span v-else class="no-data">-</span>
            </template>
        </el-table-column>
    </el-table>
</template>

<script setup lang="ts">
import { Warning } from "@element-plus/icons-vue"
import { TilaResponse } from "@/api/models/tila-response"
import { useHuonekorttiTableWithDuplicates } from "./huonekorttiTable"
import { hankePage } from "@/views/hanke"

const { id: hankeId } = hankePage()
const { isDuplicateTilatunnus } = useHuonekorttiTableWithDuplicates(hankeId)

defineProps<{
    tilat: TilaResponse[]
}>()
</script>

<style scoped>
.tilat-table {
    border-radius: 4px;
    overflow: hidden;
}

.tilat-table :deep(.el-table__header) {
    background-color: #f5f7fa;
}

.tilatunnus-cell {
    display: flex;
    align-items: center;
    gap: 8px;
}

.no-data {
    color: #909399;
    font-style: italic;
}
</style>